// extracted by mini-css-extract-plugin
export default {"menu":"ContextMenu_menu__qpEKl","item":"ContextMenu_item__ms4mo","icon":"ContextMenu_icon__gf7Yl"};